// @flow

export default (
  measurement: Object,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(measurement);
};
